/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";
import Spinner from "../../../../../components/Spinner/index";
import InputFormik from "../../../../../components/InputFormik";

import useFormStore from "../store/useStore";
import { ModalPopUp } from "../../../../../components/ModalPopUp";
import IconButton from "../../../../../components/IconButton";
import { IconGear } from "../../../../../icons";
import "./index.scss";
import ContentPopUp from "./sub-module";
import { remask } from "../../../../../libs/remask-mask";
import Input from "../../../../../components/Input";
import { ACCESS } from "../../../../Profile/constants";
import useAuthData from "../../../../../hook/useAppData";

function FormSpecificData(props: any) {
  const { updateValue, setUpdateValueObj, resultCalcPreview, modalStatus, setModalStatus } = useFormStore();
  const { modo, contract_type } = useFormStore();
  const { needSpinner } = useFormStore();
  const { saveOrSchedule, dateSchedule, handleSetDate } = useFormStore();
  const { accessIds } = useAuthData();

  const profileId = props.profile;

  function exitModalPopUp() {
    return setModalStatus(false);
  }

  const regime = verifyContract();

  function verifyContract() {
    if (Number(contract_type) === 1) return "CLT";
    if (Number(contract_type) === 2) return "PJ";
    return 0;
  }

  return (
    <Spinner status={needSpinner}>
      <ModalPopUp
        status={modalStatus}
        onClickCancel={exitModalPopUp}
        text={`${
          resultCalcPreview.total !== ""
            ? `Resultado do Calculo: R$${resultCalcPreview.total || updateValue.collaborator_cost.total || "0,00"}`
            : "Campos a serem calculados"
        }`}
      >
        <ContentPopUp regime={regime} />
      </ModalPopUp>

      <div className="collaboratorContainer">
        <div className="title-form form-box-title">
          {modo === "create" ? (
            <h1 className="align-self-end">
              {regime === "PJ"
                ? `Adicionar dados da empresa - ${updateValue.name || "profissional"}`
                : `Adicionar custos - ${updateValue.name || "profissional"}`}
            </h1>
          ) : (
            <h1 className="align-self-end">
              {regime === "PJ"
                ? `Atualizar dados da empresa - ${updateValue.name || "profissional"}`
                : `Atualizar custos - ${updateValue.name || "profissional"}`}
            </h1>
          )}
          {saveOrSchedule == "schedule" && (
            <div className="schuduleContainer">
              <div className="calendar">
                <Input label="Data Agendamento" name="teste" placeholder="" value={dateSchedule} setValue={handleSetDate} type="date" />
              </div>
            </div>
          )}
        </div>

        <Formik initialValues={updateValue.collaborator_cost} onSubmit={() => {}}>
          {(props) => (
            <form className="form-container box-form" onSubmit={props.handleSubmit}>
              {accessIds.includes(ACCESS.USERS_DATA_all) && contract_type > 0 ? (
                <IconButton icon={IconGear} text="Custos" className="icon row-edit icon-rigth" onClick={() => setModalStatus(true)} />
              ) : (
                ""
              )}
              {regime === "PJ" && (
                <>
                  <div className="row box-row">
                    <InputFormik
                      className="form-input"
                      label="CNPJ"
                      name="cnpj"
                      onChange={(e: any) => {
                        setUpdateValueObj("collaborator_cost", e.target);
                        props.handleChange(e);
                      }}
                      onBlur={props.handleBlur}
                      value={props.values.cnpj ? remask(props.values.cnpj, ["99.999.999/9999-99"]) : props.values.cnpj}
                      placeholder="Digite o CNPJ"
                      type="text"
                      required={false}
                      autofocus={true}
                    />
                    <InputFormik
                      className="form-input"
                      label="Razão Social"
                      name="corporate_name"
                      onChange={(e: any) => {
                        setUpdateValueObj("collaborator_cost", e.target);
                        props.handleChange(e);
                      }}
                      onBlur={props.handleBlur}
                      value={props.values.corporate_name}
                      placeholder="Digite a Razão Social da empresa"
                      type="text"
                      required={false}
                    />
                  </div>
                  {accessIds.includes(ACCESS.USERS_DATA_all) ? (
                    <div className="row box-row">
                      <InputFormik
                        className="form-input"
                        name="total"
                        onChange={(e: any) => {
                          setUpdateValueObj("collaborator_cost", e.target);
                          props.handleChange(e);
                        }}
                        onBlur={props.handleBlur}
                        value={resultCalcPreview.total}
                        label={`Custo Final`}
                        placeholder="Custo total do PJ"
                        type="text"
                        disabled={true}
                        required={false}
                      />
                      <InputFormik
                        className="form-input"
                        name="cost_unity"
                        onChange={(e: any) => {
                          setUpdateValueObj("collaborator_cost", e.target);
                          props.handleChange(e);
                        }}
                        onBlur={props.handleBlur}
                        value={resultCalcPreview.cost_unity}
                        label={`Custo Unitário`}
                        placeholder="Custo Unitário"
                        type="text"
                        disabled={true}
                        required={false}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
              {regime === "CLT" && (
                <div className="row box-row">
                  <InputFormik
                    className="form-input"
                    label="Custo Final"
                    name="total"
                    onChange={(e: any) => {
                      setUpdateValueObj("collaborator_cost", e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={resultCalcPreview.total}
                    placeholder="Digite o custo do CLT"
                    type="text"
                    required={false}
                    disabled
                  />
                  <InputFormik
                    className="form-input"
                    name="cost_unity"
                    onChange={(e: any) => {
                      setUpdateValueObj("collaborator_cost", e.target);
                      props.handleChange(e);
                    }}
                    onBlur={props.handleBlur}
                    value={resultCalcPreview.cost_unity}
                    label={`Custo Unitário `}
                    placeholder="Custo Unitário"
                    type="text"
                    disabled={true}
                    required={false}
                  />
                </div>
              )}
              {regime === 0 && (
                <div className="row box-row">
                  <div className="nothing-list width-100">
                    <h1>Regime de contratação não definido.</h1>
                  </div>
                </div>
              )}
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}

export default FormSpecificData;
